import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveGatsComponent } from './live-gats/live-gats.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DashbaordComponent } from './dashbaord/dashbaord.component';
import { LiveGateTypeComponent } from './live-gate-type/live-gate-type.component';
import { SystemDashboardComponent } from './system-dashboard/system-dashboard.component';



@NgModule({
  declarations: [
    LiveGatsComponent,
    DashbaordComponent,
    LiveGateTypeComponent,
    SystemDashboardComponent
  ],
  imports: [
    CommonModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule
  ]
})
export class MainDashboardModule { }
